import axios from "axios";
class COMM {
	static handle = "https://qualis.uni-saarland.de/assets/php/handle.php";
	static saveResult = "https://qualis.uni-saarland.de/assets/php/saveResult.php";
	static getQuest = async function (lsf, pw) {
		let res = await axios.post(this.handle, { lsf: lsf, password: pw });
		return res.data;
	};
	static getURL = function () {
		const urlParams = new URLSearchParams(window.location.search);
		let urlObject = {};
		urlObject.lsf = urlParams.get("l");
		urlObject.pw = urlParams.get("p");
		urlObject.demo = urlParams.get("d") === "true" ? true : false;
		return urlObject;
	};
	static sendEva = async function (data) {
		console.log(data);
		await axios
			.post(this.saveResult, data)
			.then(function () {
				return 1;
			})
			.catch(function () {
				return 0;
			});
	};
}

export default COMM;
